import { render, staticRenderFns } from "./InboxFilter.vue?vue&type=template&id=38021bc8&"
import script from "./InboxFilter.vue?vue&type=script&lang=js&"
export * from "./InboxFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38021bc8')) {
      api.createRecord('38021bc8', component.options)
    } else {
      api.reload('38021bc8', component.options)
    }
    module.hot.accept("./InboxFilter.vue?vue&type=template&id=38021bc8&", function () {
      api.rerender('38021bc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Input/Filter/InboxFilter.vue"
export default component.exports